import {
    PROPERTIES_UNITS_FETCH_INITIAL_DATA,
    FETCH_OPTIONS,
    LOG_OUT_USER,
    UPDATE_REPORT_SETTINGS
} from '../actions/actionTypes';


const optionsReducer = (state={}, action) => {
    let  options = state;
    switch(action.type){
        case PROPERTIES_UNITS_FETCH_INITIAL_DATA:
             return action.payload.options;
        case FETCH_OPTIONS:
            return {
                ...options,
                ...action.payload
            }
        case UPDATE_REPORT_SETTINGS:
            return{
                ...options,
                reportSettings: action.payload
            }
        case LOG_OUT_USER:
            return {};
        default:
            return options;
    }
};

export default optionsReducer;